// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2lnUG","signatureBlock":"Footer_signatureBlock__2GusA","signature":"Footer_signature__3uS73"};